import { Injectable, NgZone, Injector } from "@angular/core";
import { NotificationsService } from "angular2-notifications";

import { comEnvironment } from "./com/comEnvironment";
import { CoreLogService } from "./log.service";

/** UAPP CoreCOMService for Server, Plattform und Environment */
@Injectable()
export class CoreCOMService {

  private _environment: comEnvironment;

  constructor(private _notificationsService: NotificationsService,
    private _coreLogService: CoreLogService,
    private _ngZone: NgZone,
    private _injector: Injector) {
  }

  /** Environmentinteraktionen / - kommunikation  */
  public get environment(): comEnvironment {
    const me = this;
    if (!me._environment) {
      me._environment = new comEnvironment(me._notificationsService, me._coreLogService, me._ngZone, me._injector);
    }
    return me._environment;
  }
}
